import { useFieldArray } from "react-hook-form";
import { useFormContext } from "react-hook-form";

const useFieldArrayClean = (options) => {
    const { getValues } = useFormContext();
    const { replace, ...fieldArray } = useFieldArray(options);

    const remove = (index) => {
        const current = getValues(options.name) ?? [];
        replace(current.filter((_, i) => i !== index));
    };

    return { ...fieldArray, replace, remove };
};

export default useFieldArrayClean;